import { hotList, type HotItem } from "@/mocks/chigua";

const rankClass = (r: number) =>
  r === 1
    ? "bg-primary-500 text-background-50"
    : r === 2
    ? "bg-secondary-500 text-background-50"
    : r === 3
    ? "bg-accent-500 text-background-50"
    : "bg-background-200 text-foreground-600";

function Item({ item }: { item: HotItem }) {
  return (
    <li>
      <a
        href="#field"
        className="group flex items-center gap-4 rounded-xl border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-4"
      >
        <span
          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-sm font-bold ${rankClass(item.rank)}`}
        >
          {item.rank}
        </span>
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-700 md:text-base">
            {item.title}
          </p>
          <p className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
            <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-900">{item.tag}</span>
            <span>{item.heat}</span>
            <span className="hidden sm:inline">已盖 {item.floors}</span>
          </p>
        </div>
        <span
          className={`flex shrink-0 items-center gap-0.5 text-xs font-medium ${
            item.up ? "text-primary-600" : "text-foreground-400"
          }`}
        >
          <i className={`${item.up ? "ri-arrow-up-line" : "ri-arrow-down-line"} text-sm leading-none`} />
          {item.up ? "上升" : "回落"}
        </span>
      </a>
    </li>
  );
}

export default function HotRank() {
  return (
    <section id="hot" className="scroll-mt-20 bg-background-100/70 py-10 md:py-14">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-widest text-primary-600">TOP RANKS</span>
            <h2 className="mt-1 text-2xl text-foreground-950 md:text-4xl">今日瓜田热榜</h2>
          </div>
          <p className="text-sm text-foreground-600">楼层跟进新进展，热榜随更新实时变动</p>
        </div>

        <ol className="mt-7 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {hotList.map((item) => (
            <Item key={item.id} item={item} />
          ))}
        </ol>
      </div>
    </section>
  );
}